<template>
  <!--components/guessYouLikePopups/guessYouLikePopups.wxml-->
  <div class="popups" v-if="isShowLikePopups">
    <div class="popups-content" v-for="(item,index) in likeRoutePopupsList" :key="index">
      <div class="popups-content-title">您关注的航线优惠进行中，抓紧锁定心仪假期</div>
      <div class="close" @click="onChangeClose"><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/icon-closed.png" alt=""></div>
      <div class="popups-content-main" @click="onCruiseClick($event,item.shipCode,
            item.sailDate,)">
        <div class="main-left">
<!--          <img class="img-wrapper-tag" src="../../assets/browse.png" alt="">-->
          <div class="img-wrapper-tag">{{item.customizeTag}}</div>
          <div class="main-wrapper-img"><img :src="item.mobileImage"  alt=""/></div>
        </div>
        <div class="main-right">
          <div class="main-right-title">{{item.cruiseName}}</div>
          <div class="main-right-mark">
            <span>{{item.routeDays}}天{{item.routeDays-1}}晚</span> <span class="main-partition">|</span> <span>{{item.shipCNName}}</span>
          </div>
          <div class="main-right-mark">
            {{ getSailDate(item) }}
          </div>
          <div class="price-content">
            <span class="price-prompt">{{item.remark}}：</span><span class="price-unit">￥</span><span class="current-price">{{item.netAmount}}</span>
            /<span class="price-text">人起(含税)</span>
          </div>
          <div class="old-price">
            ￥{{item.originalAmount}} /人起(含税)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    likeRoutePopupsList:{
      type:Array,
      default: () => {
        return [];
      },
    }
  },
  data(){
   return{
     isShowLikePopups: true
   }
  },
  methods:{
    getSailDate(item) {
      let sailDateBegin = item.sailDateBegin.split(" (")[0];
      let sailDateEnd = item.sailDateEnd.split(" (")[0];
      return `${sailDateBegin}-${sailDateEnd}`;
    },
    onChangeClose(){
      this.$store.commit('SET_LIKE_ROUTE_POPUPS',false)
      this.isShowLikePopups = this.$store.state.user.isShowLikePopups
    },
    onCruiseClick(e,shipCode,sailDate){
      sailDate = sailDate.split("T")[0];
      this.$router.push({
        name: "CruiseDetail",
        query:{shipCode: shipCode, sailDate: sailDate}
      })
    }
  },
  computed:{

  },

}
</script>
<style scoped lang="less">
.popups {
  position: fixed;
  bottom: 45px;
  width: 100%;
  height: 167px;
  z-index: 1001;
  padding: 0 15px;
}

.popups-content {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 17, 17, 0.88);
  margin: 0 auto;
  border-radius: 10px;
  padding: 9px 11px 5px;
  position: relative;
}

.popups-content-title {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 17px;
  text-align: center;
  padding-bottom: 7px;
  border-bottom: 1px solid #ffffff;
}

.popups-content-main {
  margin-top: 11px;
  display: flex;
  color: #ffffff;
}

.main-left {
  width: 78px;
  height: 110px;
  border-radius: 4px;
  //overflow: hidden;
  margin-right: 12px;
  position: relative;
}
.main-left .img-wrapper-tag{
  background: url("../../assets/likeTageBg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  width: 49px;
  height: 20px;
  left: -3px;
  top: 9px;
  font-size: 9px;
  line-height: 15px;
  text-align: center;
  color: #FFFFFF;
}
.main-wrapper-img{
  width: 100%;
  height: 110px;
  overflow: hidden;
  border-radius: 4px;
}
.main-right {
  width: 225px;
  margin-top: -3px;
}
img{
  width: 100%;
  height: 100%;
}
.main-right-title {
  //height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 20px;
}

.main-right-mark {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 17px;
  margin-top: 3px;
}
.main-partition{
  display: inline-block;
  margin: 0 5px;
}
.price-content {
  height: 22px;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;

  color: #FFFFFF;
  line-height: 17px;
  margin-top: 2px;
}
.price-prompt{
  font-weight: 600;
}
.current-price {
  color: #FCC300;
  font-size: 16px;
  font-weight: 600;
}
.price-text{
  font-size: 11px;
}
.price-unit {
  color: #FCC300;
  font-size: 13px;
}

.old-price {
  color: #c4c4c4;
  font-size: 10px;
  text-decoration: line-through;
  /* margin-left: 20px; */
}

.close {
  position: absolute;
  color: #ffffff;
  font-size: 19px;
  width: 16px;
  height: 16px;
  top: 3px;
  right: 8px;
}
</style>
